import { CardRoot } from './styles';

interface CardsProps {
  children: React.ReactNode;
  variant?: 'default' | 'primary';
}

const Cards = ({ children, variant = 'default' }: CardsProps) => {
  return <CardRoot variant={variant}>{children}</CardRoot>;
};

export default Cards;
